import { useEffect, useState } from 'react';
import socket from '../services/websocket';

export function useWebSocket() {
    const [lastMessage, setLastMessage] = useState(null);

    useEffect(() => {
        const onSensor = (data) => setLastMessage(JSON.stringify({ type: 'sensor_update', ...data }));
        const onRelay = (data) => setLastMessage(JSON.stringify({ type: 'relay_update', ...data }));
        socket.on('sensor_update', onSensor);
        socket.on('relay_update', onRelay);
        return () => {
            socket.off('sensor_update', onSensor);
            socket.off('relay_update', onRelay);
        };
    }, []);

    const sendMessage = (msg) => socket.emit('message', msg);

    return { lastMessage, sendMessage };
}
